//Quick View
var selectedVariant = '';
var uuid = '';
var is_bundle = false ;
var properties_msg = '' ;
$(document).ready(function () {
  quickView();
});

function log_product_action (variant_id,uuid,action,properties_msg) {
  const log_data = {
    "master_variant_id": window.currentVariant.id,
    "slave_variant_id": variant_id,
    "uuid": uuid ,
    "add_to_cart": action,
    "msg":properties_msg
  }
  log_bundle_set(log_data)
}

function log_bundle_set(data) {
  fetch("https://objektslab.co.uk/api/shopify/analysis/product-sale-items/impressions", {
    body: JSON.stringify(data),
    credentials: "same-origin",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest"
    }
  })
}

function quickView() {
  var this_button ;
  $(".quick-view").off("click").on("click",function(){
    selectedVariant = ''; // reset first select variant
    this_button = $(this);
    is_bundle = this_button.attr('data-bundle') ? this_button.attr('data-bundle') : false;
    properties_msg = this_button.attr('data-msg') ? this_button.attr('data-msg') : '';
    const fixed_discount = this_button.attr('data-discount') ? this_button.attr('data-discount') : '';
    toggleLoading(this_button)
    if ($('#quick-view').length == 0){$("body").append('<div style="display: none;width: 1000px;max-height: 100%;overflow-y: auto;opacity:0"id="quick-view"><div class="bundle-builder-app--product-modal--content"><div class="bundle-builder-app--product-modal--product"><div class="bundle-builder-app--bundle--product-link"><div class="qv-product-images"><!--Swiper--><div class="swiper-container gallery-top"><div class="swiper-wrapper"></div><!--Add Arrows--><div class="swiper-button-next swiper-button-white"></div><div class="swiper-button-prev swiper-button-white"></div><div class="swiper-pagination"></div></div></div></div><div class="bundle-builder-app--bundle--product-details"><div class="qv-content"><div class="holder"><h3 class="bundle-builder-app--bundle--product-name qv-product-title"></h3><div class="rte bundle-builder-app--bundle--product-description qv-product-description"></div><div class="bundle-builder-app--bundle--product-options-form"><div class="qv-product-options"></div></div><div class="bundle-builder-app--bundle--product-price qv-product-price"><span class="money"></span></div><div class="qv-add-to-cart"><div style="display:none;"class="bundle-builder-app--bundle--soldout"><span>Sold out</span></div><div class="bundle-builder-app--bundle--product-add--wrapper"><button type="button"class="bundle-builder-app--button  select-builder-item"tabindex="0"><span>Select</span></button><button type="button"class="Button bundle-builder-app--button bundle-builder-app--bundle--product-add-button"tabindex="0"><span>Add</span><div class="loading-overlay__spinner hidden"><svg aria-hidden="true"focusable="false"role="presentation"class="spinner"viewBox="0 0 66 66"xmlns="http://www.w3.org/2000/svg"><circle class="path"fill="none"stroke-width="6"cx="33"cy="33"r="30"></circle></svg></div></button></div></div><div class="qv-add-to-cart-response"></div></div></div></div></div></div>');}
    var product_handle = $(this).attr('data-handle');
    $('#quick-view').attr( 'data-handle' , product_handle );
    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
      var title = product.title;
      var type = product.type;
      var price = 0;
      var original_price = 0;
      var desc = product.description;
      var media = product.media;
      var variants = product.variants;
      
      $(product.variants).each(function (i, v) {
        var v_available = v.available;
        
        if (v_available == true && selectedVariant == '') {
          console.log(v_available)
          console.log(v.option1)
          console.log(v.option2)
          console.log(v.option3)
          selectedVariant = v;
        }

      });
      if (selectedVariant == ''){
        console.log('赋值')
        selectedVariant = variants[0];
      }
      console.log(selectedVariant.available)
      var options = product.options;
//       console.log(product);
      var url = '/products/' + product_handle;
      $('.qv-product-title').text(title);
      $('.qv-product-type').text(type);
      $('.qv-product-description').html(desc);
      $('.view-product').attr('href', url);
      var imageCount = $(media).length;
      $(media).each(function (i, item) {
        const altText = item.alt?item.alt:'';
        if(altText.indexOf('hidden') == -1 ){
          var image_embed = '<div class="swiper-slide" style="background-image:url(' + item.src + ')"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.gallery-top .swiper-wrapper').append(image_embed);
          // $('.gallery-thumbs .swiper-wrapper').append(image_embed);
        }
        

      });
      
      $(options).each(function (i, option) {
        var opt = option.name;
        var selectClass = 'option-' + i;
        $('.qv-product-options').append('<div class="bundle-builder-app--bundle--product-options option-selection-' + opt.toLowerCase() + '"><label for="product-option-0" class="bundle-builder-app--bundle--product-select-label">' + opt + '</label><div class="bundle-builder-app--bundle--product-select-container"><select class="bundle-builder-app--bundle--product-select ' + selectClass + '" tabindex="0"></select></div></div>');
        $(option.values).each(function (i, value) {
          $('.'+selectClass).append('<option value="' + value + '">' + value + '</option>');
        });
      });

      if (selectedVariant.available == false) {
        console.log('Sold out')
        $('.bundle-builder-app--bundle--product-add-button span').text('Sold out');
        $('.bundle-builder-app--bundle--product-add-button').attr('disabled',true);
        $('.bundle-builder-app--bundle--product-add-button').addClass('is_soldout');
      }else{
        if (fixed_discount){
          const price_html = '<div class="Price--highlight">'+Shopify.formatMoney((selectedVariant.price - selectedVariant.price * 0.1) ,window.theme.moneyFormat)+'</div>';
          const compare_at_price_html = '<div class="Price--compareAt">'+Shopify.formatMoney(selectedVariant.price,window.theme.moneyFormat)+'</div>';
          $('.bundle-builder-app--bundle--product-price').html( price_html + compare_at_price_html);
        }else if (selectedVariant.price < selectedVariant.compare_at_price) {
          const price_html = '<div class="Price--highlight">'+Shopify.formatMoney(selectedVariant.price,window.theme.moneyFormat)+'</div>';
          const compare_at_price_html = '<div class="Price--compareAt">'+Shopify.formatMoney(selectedVariant.compare_at_price,window.theme.moneyFormat)+'</div>';
          $('.bundle-builder-app--bundle--product-price').html( price_html + compare_at_price_html);
        }else {
          $('.bundle-builder-app--bundle--product-price').html(Shopify.formatMoney(selectedVariant.price,window.theme.moneyFormat));
        }
        $('.bundle-builder-app--bundle--product-add-button span').text('Add');
        $('.bundle-builder-app--bundle--product-add-button').attr('disabled',false);
        $('.bundle-builder-app--bundle--product-add-button').removeClass('is_soldout');
        $('select.option-0').val(selectedVariant.option1);
        $('select.option-1').val(selectedVariant.option2);
        $('select.option-2').val(selectedVariant.option3);
      }
      

      $(".select-builder-item").off("click").on("click",function(){ 
        ProductBuilder.doSelectProduct();
      });
      toggleLoading(this_button)
      $('[data-src="#quick-view"]').click()
      $('.qv-product-description').readmore({
        speed: 75,
        collapsedHeight:0,
        moreLink: '<a class="show-description" href="#">Show description</a>',
        lessLink: '<a class="hide-description" href="#">Hide description </a>'
      });
      var galleryThumbs = new Swiper('.gallery-thumbs', {
        spaceBetween: 10,
        slidesPerView: 4,
        loop: true,
        freeMode: true,
        loopedSlides: 5, //looped slides should be the same
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      });
      var galleryTop = new Swiper('.gallery-top', {
        spaceBetween: 10,
        loop: true,
        loopedSlides: 5, //looped slides should be the same
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: ".swiper-pagination",
        }
        // thumbs: {
        //   swiper: galleryThumbs,
        // },
      });
    });
    //$("#quick-view select").off("change");
    $("#quick-view").on("change", function () {
      let _this_button = $(this).find('.bundle-builder-app--bundle--product-add-button');
      var selectedOptions = '';
      $('#quick-view select').each(function (i) {
        if (selectedOptions == '') {
          selectedOptions = $(this).val();
        } else {
          selectedOptions = selectedOptions + ' / ' + $(this).val();
        }
      });
      toggleLoading(_this_button)
     
      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        $(product.variants).each(function (i, v) {
          var v_available = v.available;
          var v_inv = v.inventory_management;
          
           
          if (v.title == selectedOptions) {
            selectedVariant = v;
            // var price = Shopify.formatMoney(v.price,window.theme.moneyFormat)
            if (fixed_discount){
              const price_html = '<div class="Price--highlight">'+Shopify.formatMoney((selectedVariant.price - selectedVariant.price * 0.1) ,window.theme.moneyFormat)+'</div>';
              const compare_at_price_html = '<div class="Price--compareAt">'+Shopify.formatMoney(selectedVariant.price,window.theme.moneyFormat)+'</div>';
              $('.bundle-builder-app--bundle--product-price').html( price_html + compare_at_price_html);
            }else if (selectedVariant.price < selectedVariant.compare_at_price) {
              const price_html = '<div class="Price--highlight">'+Shopify.formatMoney(selectedVariant.price,window.theme.moneyFormat)+'</div>';
              const compare_at_price_html = '<div class="Price--compareAt">'+Shopify.formatMoney(selectedVariant.compare_at_price,window.theme.moneyFormat)+'</div>';
              $('.bundle-builder-app--bundle--product-price').html( price_html + compare_at_price_html);
            }else {
              $('.bundle-builder-app--bundle--product-price').html(Shopify.formatMoney(selectedVariant.price,window.theme.moneyFormat));
            }
            if (v_inv == null) {
              $('.bundle-builder-app--bundle--product-add--wrapper').show();
            }else{
              if (v_available == false) {
                $('.bundle-builder-app--bundle--product-add-button span').text('Sold out');
                console.log(v_available)
                $('.bundle-builder-app--bundle--product-add-button').attr('disabled',true);
                console.log($('.bundle-builder-app--bundle--product-add-button').attr('disabled'))
                $('.bundle-builder-app--bundle--product-add-button').addClass('is_soldout');
              }else{
                $('.bundle-builder-app--bundle--product-add-button span').text('Add');
                $('.bundle-builder-app--bundle--product-add-button').attr('disabled',false);
                $('.bundle-builder-app--bundle--product-add-button').removeClass('is_soldout');
              }
            }
          }
          
        });
        toggleLoading(_this_button)
      });
    });

  });
  
  

  $("#quick-view-controller").fancybox({
    'beforeLoad': function () {
      var product_handle = $('#quick-view').attr('data-handle');
      // $('.bundle-builder-app--bundle--product-add-button span').text('Add');
      uuid = uuidv4();
      log_product_action(selectedVariant.id,uuid,0,properties_msg)
      $(".bundle-builder-app--bundle--product-add-button").click(function(){
        this_button = $(this);
        toggleLoading(this_button)
        var qty = 1;
        var selectedOptions = '';
        var var_id = '';
        
        $('#quick-view select').each(function (i) {
          if (selectedOptions == '') {
            selectedOptions = $(this).val();
          } else {
            selectedOptions = selectedOptions + ' / ' + $(this).val();
          }
        });
        jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
          $(product.variants).each(function (i, v) {
            if (v.title == selectedOptions) {
              var_id = v.id;
              selectedVariant = v;
              if (typeof excludeProducts !== 'undefined') {
                console.log(excludeProducts)
                is_bundle = excludeProducts.indexOf(product.id) != -1 ? 0 : 1 ;
              }
              processCart();
            }
          });
        });
        function processCart() {
          console.log(is_bundle)
          let add_to_cart_datas = [];
          let cart_items_total_price = 0;
          let cart_items_subtotal_price = 0;
          cart_items_total_price = window.currentVariant.price * 1 + selectedVariant.price * 1;
          cart_items_subtotal_price = cart_items_total_price - selectedVariant.price * 0.1;
          document.dispatchEvent(new CustomEvent("theme:loading:start"));
          if (is_bundle) {
              let master_add_to_cart_data = {
                "id":window.currentVariant.id,
                "quantity": 1,
                "properties": {
                  "_bundle_image":window.currentVariant.featured_image.src+','+selectedVariant.featured_image.src,
                  "_custom_bundle":true,
                  "_uuid":uuid,
                  "_msg":properties_msg,
                  //"_type":'centerpiece',
                  "_bundle_position": 'master',
                  "_line_item_quantity":1,
                  "_quantity":2,
                  "_total_price": (cart_items_total_price / 100 / GeoCurrencyRate),
                  "_objkts_bundle_price":(cart_items_subtotal_price / 100 / GeoCurrencyRate ),
                  "_origin_price":(window.currentVariant.price / 100  / GeoCurrencyRate)
                }
              };
              add_to_cart_datas.push(master_add_to_cart_data);
              let slave_add_to_cart_data = {
                "id":selectedVariant.id,
                "quantity": 1,
                "properties": {
                  "_bundle_image": window.currentVariant.featured_image.src+','+selectedVariant.featured_image.src,
                  "_custom_bundle":true,
                  "_uuid":uuid,
                  "_msg":properties_msg,
                  //"_type":'centerpiece',
                  "_bundle_position": 'slave',
                  "_line_item_quantity":1,
                  "_quantity":2,
                  "_total_price": (cart_items_total_price / 100 / GeoCurrencyRate),
                  "_objkts_bundle_price":(cart_items_subtotal_price / 100 / GeoCurrencyRate ),
                  "_origin_price":(selectedVariant.price / 100  / GeoCurrencyRate)
                }
              };
              add_to_cart_datas.push(slave_add_to_cart_data);
         }else {
              let slave_add_to_cart_data = {
                "id":selectedVariant.id,
                "quantity": 1,
                "properties": {
                  "_uuid":uuid,
                  "_msg": properties_msg,
                }
            };
              add_to_cart_datas.push(slave_add_to_cart_data);
         }
        console.log(add_to_cart_datas)
          // return false;
          fetch('/cart/add.js', {
            body: JSON.stringify({items:add_to_cart_datas}),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
            }
          }).then(function (response) {
              console.log(response)
              if (response.status == 200) {
                log_product_action(selectedVariant.id,uuid,1,properties_msg)
                if (is_bundle) {
                 
                  setTimeout(function(){
                    window.location.href = '/cart';
                  }, 1000);
                }else {
                  $.fancybox.close();
                  //$.fancybox.destroy();
                  productAdded()
                }
              }else{
                let response_json = response.json();
                response_json.then(function (result) {
                  // _this.cart_error_message = result.description
                  $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + result.description);
                })
                toggleLoading(this_button)
              }
              
              document.dispatchEvent(new CustomEvent('theme:loading:end'));
              
          }).catch((error) => {
            console.error('Error:', error);
          });
        }
	  });
      $('.fancybox-wrap').css('overflow', 'hidden !important');
    },
    'afterShow': function () {
      $('#quick-view').hide().css('opacity', '1').fadeIn(function () {
        //         $('.qv-product-images').addClass('loaded');
      });
    },
    'afterClose': function () {
//       console.log(11)
      $('.gallery-top .swiper-wrapper').html("");
      $('.gallery-thumbs .swiper-wrapper').html("");
      $('.qv-product-options').html("");
      $('.qv-add-to-cart-response').html("");
      $('.qv-add-to-cart-response').removeClass("success");
      $('.qv-add-to-cart-response').removeClass("error");
      $('#quick-view').remove(); 
      
    }
  });

};

